import { withTranslation } from "react-i18next";

import TranslateDetail from './TranslateDetail';

export default withTranslation(undefined, { withRef: true })(TranslateDetail);